import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

// Store Management
export const getAllStores = async () => {
  try {
    const response = await axiosInstance.get('/Stores/get-stores');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const searchStores = async (searchTerm) => {
  try {
    const response = await axiosInstance.get('/Stores/search', {
      params: { searchTerm }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getStoreUsers = async (storeId) => {
  try {
    const response = await axiosInstance.get(`/Stores/${storeId}/users`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createStore = async (storeData) => {
  try {
    const response = await axiosInstance.post('/Stores/add-store', storeData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateStore = async (storeId, storeData) => {
  try {
    // Backend expects the full DTO with Id included in the body
    const payload = {
      ...storeData,
      Id: storeId
    };
    const response = await axiosInstance.put('/Stores/update-store', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteStore = async (storeId) => {
  try {
    const response = await axiosInstance.delete(`/Stores/delete/${storeId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const activateStore = async (storeId) => {
  try {
    const response = await axiosInstance.post(`/Stores/${storeId}/activate`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deactivateStore = async (storeId) => {
  try {
    const response = await axiosInstance.post(`/Stores/${storeId}/deactivate`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Store-User Assignment
export const assignUserToStore = async (userId, storeId) => {
  try {
    const response = await axiosInstance.post('/Stores/assign-user', { userId, storeId });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const removeUserFromStore = async (userId) => {
  try {
    const response = await axiosInstance.post(`/Stores/remove-user/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const moveUserToStore = async (userId, fromStoreId, toStoreId) => {
  try {
    const response = await axiosInstance.post('/Stores/move-user', { 
      userId, 
      fromStoreId, 
      toStoreId 
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
